import { useAtomValue } from 'jotai';
import { navigationPlayerIdAtom } from '@/atoms/navigation';
import { SwitchToClassicButton } from './SwitchToClassicButton';

export const SwitchToClassicPlayerButton = () => {
  const iqPlayerId = useAtomValue(navigationPlayerIdAtom).iqId;
  const classicIqPlayerPath = `player/${iqPlayerId}`;

  return (
    <SwitchToClassicButton
      path={classicIqPlayerPath}
      navOverrides={{
        player: true,
      }}
    />
  );
};
